import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-762cc61b"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["disabled"]
const _hoisted_2 = { class: "inner" }

import { computed, toRefs } from 'vue';
  import { useRouter } from 'vue-router';
  import { getColors } from '../../baseHocks';
  import BaseIcon from '../../BaseIcon/src/BaseIcon.vue';
  import { buttonProps } from './props';
  
  import { defineComponent } from 'vue';
  const __default__ = defineComponent({
    name: 'BaseButton',
  });

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: buttonProps,
  emits: ['click'],
  setup(__props, { emit }) {

const props = __props

  
  
  const { size, icon, disabled, loading, type, link } = toRefs(props);
  const router = useRouter();
  const realIcon = computed(() => {
    if (loading.value === true) {
      return 'loading';
    }
    return icon.value;
  });

  const hasIcon = computed(() => {
    return realIcon.value != '';
  });
  const isLink = computed(() => link.value != '');

  const isRealDisabled = computed(() => disabled.value || loading.value);
  const handleClick = (evnt: MouseEvent) => {
    if (isLink.value) {
      router.push(link.value);
    }
    emit('click', evnt);
  };

  const { innerColor } = getColors(type);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    disabled: _unref(isRealDisabled),
    class: _normalizeClass([_unref(size), 'base-button', _unref(type) + '-bg']),
    onClick: handleClick
  }, [
    (_unref(hasIcon))
      ? (_openBlock(), _createBlock(BaseIcon, {
          key: 0,
          class: "icon",
          color: _unref(innerColor),
          name: _unref(realIcon)
        }, null, 8, ["color", "name"]))
      : _createCommentVNode("", true),
    _createElementVNode("span", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 10, _hoisted_1))
}
}

})